import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=2a3ea3d3&scoped=true&"
import script from "./Tooltip.vue?vue&type=script&lang=ts&"
export * from "./Tooltip.vue?vue&type=script&lang=ts&"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=2a3ea3d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3ea3d3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsInfoCircle16px: require('/var/www/packages/theme/components/icons/info-circle/InfoCircle16px.vue').default})
